module.exports = __webpack_public_path__ + "img/FAQ.6ce6b953.svg";